import axios from 'axios';

import { ACTIONS } from '../actions';

export const createOrder = ({
  buyingUserId,
  buyingUserEmail,
  statusId = 1,
  serviceId,
  eventBookingId,
  orderRows = [],
  successUrl,
  cancelUrl,
}) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.CREATE_ORDER_START });

    try {
      const response = await axios.post('/order/public/create', {
        buying_user_id: buyingUserId,
        buying_user_email: buyingUserEmail,
        status_id: statusId,
        service_id: serviceId,
        event_booking_id: eventBookingId,
        success_url: successUrl,
        cancel_url: cancelUrl,
        order_rows: orderRows.map((row) => ({
          ...(row.orderItemsId != null ? { order_items_id: row.orderItemsId } : {}),
          ...(row.partsId != null ? { parts_id: row.partsId } : {}),
          ...(row.partsArtNo ? { parts_art_no: row.partsArtNo } : {}),
          ...(row.shopifyProductVariantId
            ? { shopify_product_variant_id: row.shopifyProductVariantId }
            : {}),
          name: row.name ?? '',
          description: row.description ?? '',
          unit_price: row.unitPrice ?? 0,
          currency_id: row.currencyId ?? 1,
          unit: row.unit ?? 'fixed',
          quantity: row.quantity ?? 1,
          type: row.type ?? 'part',
          vat: row.vat ?? 25,
          discount: row.discount ?? 0,
          is_approved_by_customer: row.isApprovedByCustomer ?? true,
        })),
      });

      const data = response?.data?.data || {};

      dispatch({
        type: ACTIONS.CREATE_ORDER_SUCCESS,
        payload: {
          order: data.order || null,
          paymentLink: data.payment_link || null,
        },
      });

      return data;
    } catch (error) {
      const message =
        error?.response?.data?.error?.message ||
        error?.response?.data?.error?.cause ||
        'Failed to create order';

      dispatch({
        type: ACTIONS.CREATE_ORDER_FAILURE,
        payload: message,
      });

      throw error;
    }
  };
};

export const getProductsByCollections = ({
  page = 1,
  perPage = 20,
  collections = [],
  optionAs = ['Color', 'Size', '__empty__'],
  userId = null,
}) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.GET_ORDER_PRODUCTS_BY_COLLECTIONS_START });

    try {
      const response = await axios.post(
        `/order/public/shopify/products/by-collections?page=${page}&per_page=${perPage}`,
        {
          collections,
          option_as: optionAs,
          ...(userId != null && { user_id: userId }),
        }
      );

      const data = response?.data?.data || {};

      dispatch({
        type: ACTIONS.GET_ORDER_PRODUCTS_BY_COLLECTIONS_SUCCESS,
        payload: {
          availableOptionLabels: data.available_option_labels || [],
          paginator: data.paginator || null,
          results: data.results || [],
        },
      });
    } catch (error) {
      dispatch({
        type: ACTIONS.GET_ORDER_PRODUCTS_BY_COLLECTIONS_FAILURE,
        payload:
          error?.response?.data?.error?.message ||
          error?.response?.data?.error?.cause ||
          'Failed to fetch products by collections',
      });
    }
  };
};

export const getOrderBySessionId = (sessionId) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.GET_ORDER_BY_SESSION_START });

    try {
      const response = await axios.get(`/order/public/session/${encodeURIComponent(sessionId)}`);

      const data = response?.data?.data || {};

      dispatch({
        type: ACTIONS.GET_ORDER_BY_SESSION_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      const message =
        error?.response?.data?.error?.message ||
        error?.response?.data?.error?.cause ||
        'Failed to fetch order';

      dispatch({
        type: ACTIONS.GET_ORDER_BY_SESSION_FAILURE,
        payload: message,
      });

      throw error;
    }
  };
};
